import './Snapshot.css';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import config from '@config';
import { isWordCupStarted } from '@selectors/clock';
import Bracket from '@layout/BracketLayout';
import Announcement from '@views/Announcement';
import Groups from '@views/Groups';

export const Snapshot = ({ showSnapshot }) => (
  <div id="Snapshot" className={showSnapshot ? 'snapshot-mode' : 'Snapshot'}>
    <Announcement />
    <div className="hero-bg">
      <div className="hero-content">
        <h2>Tu mundial ideal</h2>
        {showSnapshot ? (
          <p>
            Completa tu pronóstico para cada uno de los partidos. Si bien podés hacerlo en cualquier momento, para competir por los puntos extra de "Mi Mundial ideal" tenés que cargar los resultados antes del comienzo del primer partido del Mundial, que se jugará el 11 de Junio y no realizar ningún cambio durante el torneo.
          </p>
        ) : (
          <p>
            Completa tu pronóstico para cada uno de los partidos. Si bien podés hacerlo en cualquier momento, para competir por los puntos extra de "Mi Mundial ideal" tenés que cargar los resultados antes del comienzo del primer partido del Mundial, que se jugará el 11 de Junio y no realizar ningún cambio durante el torneo.
          </p>
        )}
      </div>
    </div>
    <div className="snapshot-container">
      {showSnapshot ? (
        <div>
          <Groups />
          <Bracket />
        </div>
      ) : (
        <div className="card">
          <h2>Próximamente</h2>
          <p>Una vez que comience la Copa aquí va a quedar tu Mundial ideal</p>
        </div>
      )}
    </div>
  </div>
);

Snapshot.propTypes = {
  showSnapshot: PropTypes.bool,
};
Snapshot.defaultProps = {
  showSnapshot: false,
};

export const mapStateToProps = (state) => ({
  showSnapshot: isWordCupStarted(state),
});

export default connect(mapStateToProps)(Snapshot);
